<template lang="pug">
  div.items-area(:data-test="slits")
    div.slit(v-for="(n , i) in slits",v-if="i !== slits.length - 1",:style="sty(i)")
      div.items(:style="styItems()")
        Item(v-for="(nc , ss) in slits[i].item",:dat="nc",:pnum="i",:num="ss",:key="ss")
      div.flr(:style="styFloor()")
        FItem(v-for="(nc , ss) in slits[i].floor",:dat="nc",:pnum="i",:num="ss",:key="ss")

</template>

<script>
import Item from './Item.vue';
import FItem from './FItem.vue';
export default {
  name: 'Items',
  components: {
    Item,
    FItem
  },
  data () {
    return {
      parent: 0,
      child: 0,
      height: 0,
      $tar: {},
      dragged: {},
      slits: []
    };
  },
  computed: {
  },
  watch: {
    number () {
      this.slits = this.sets[this.number].slits;
    },
    sets () {
      this.slits = this.sets[this.number].slits;
    }
  },
  methods: {
    sty (num) {
      let width = this.c2p(this.slits[num + 1].pos - this.slits[num].pos);
      this.height = this.c2p(this.sets[this.number].size[1]);
      let left = this.c2p(this.slits[num].pos);
      return {
        width: width + 'px',
        height: 0 + 'px',
        left: left + 'px'
      };
    },
    styItems () {
      let height = this.c2p(this.sets[this.number].size[1]);
      return {
        height: height + 'px',
        zindex: 2
      };
    },
    styFloor () {
      let height = this.c2p(this.sets[this.number].size[3]);
      return {
        height: height + 'px'
      };
    }
  },
  created () {
    this.slits = this.sets[this.number].slits;
  },
  mounted () {
  }
};
</script>

<style lang="stylus" scoped>
  .items-area
    left 0
    top 0
    position absolute
    z-index 1
    .slit
      position absolute
      left 0
      top 0
      width 170px
      height 48px
      &.over
        .item,
        .prev
          display block
          pointer-events none
      .items
        z-index 2
        position absolute
        left 0
        top 0
      .flr
        position absolute
        left 0
        top 0

</style>



// WEBPACK FOOTER //
// src/components/top/Items.vue